import { BASVURU_ANA_DURUM_TURLERI_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const basvuruAnaDurumTurleriList = () => {
    return getRequest({url:BASVURU_ANA_DURUM_TURLERI_LISTESI});
}

export default basvuruAnaDurumTurleriList;